module.exports = __webpack_public_path__ + "img/check.54739bb5.svg";